import * as actionTypes from '../actions/actionTypes';
import * as constants from '../../constants';

import { updateState } from '../../lib/StateHelper';

const initialState = {
  franchiseAgentProductFee: null,
  franchiseAgentProductFees: null,
  isNew: false,
  lastState: null,
  lastScope: null
};

const franchiseAgentProductFeeReducer = (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.FRANCHISEAGENTPRODUCTFEE_START: {
      return updateState(state, { ...action.data, lastState: constants.STATE_PROCESSING });
    }
    case actionTypes.FRANCHISEAGENTPRODUCTFEE_SUCCESS: {
      return updateState(state, { ...action.data, lastState: constants.STATE_SUCCESS });
    }
    case actionTypes.FRANCHISEAGENTPRODUCTFEE_FAIL: {
      return updateState(state, { lastState: constants.STATE_FAIL });
    }
    case actionTypes.FRANCHISEAGENTPRODUCTFEE_LISTRESET: {
      return updateState(state, { ...action.data, lastState: constants.STATE_RESET, lastScope: 'reset' });
    }
    default: {
      return state;
    }
  }
};

export default franchiseAgentProductFeeReducer;
